import { VacationRentalWidget as Widget } from 'shared/widget/fhh/VacationRentalWidget';
import { safeFormatISODate } from 'shared/util/datetime-fns';

import type { Filters, SearchDestination } from '@/interfaces';
import { nameOverrides } from '@/utils/nameOverrides';

export interface VacationRentalWidgetProps {
    filters: Filters;
    destination?: SearchDestination;
}
export const VacationRentalWidget = ({ destination, filters }: VacationRentalWidgetProps) => {
    if (!destination && !filters.mapBounds) {
        return null;
    }
    const lngSw = filters.mapBounds ? filters.mapBounds.sw[0] : destination.longitude - 0.0812;
    const latSw = filters.mapBounds ? filters.mapBounds.sw[1] : destination.latitude - 0.0812;
    const lngNe = filters.mapBounds ? filters.mapBounds.ne[0] : destination.longitude + 0.0812;
    const latNe = filters.mapBounds ? filters.mapBounds.ne[1] : destination.latitude + 0.0812;
    const placeName = filters.mapBounds ? undefined : (nameOverrides[filters.destination] ?? destination?.fullName);
    return (
        <Widget
            destination={placeName}
            lngSw={lngSw}
            latSw={latSw}
            lngNe={lngNe}
            latNe={latNe}
            bookingFrom={safeFormatISODate(filters.checkInDate, null)}
            bookingTo={safeFormatISODate(filters.checkOutDate, null)}
        />
    );
};
